<template>
    <section>
      <el-dialog
        title="新增"
        :visible.sync="addFormVisible"
        v-model="addFormVisible"
        :close-on-click-modal="false"
        :before-close="closetc"
      >
        <el-form
          :model="addForm"
          label-width="120px"
          :rules="addFormRules"
          ref="addForm"
        >
          <el-form-item label="名称" prop="Name">
            <el-input v-model="addForm.Name" auto-complete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closetc">关闭</el-button>
          <el-button
            type="primary"
            @click.native="addSubmit"
            :loading="addLoading"
            >提交</el-button
          >
        </div>
      </el-dialog>
    </section>
  </template>
  
  
  
  <script>
  import { addMachinesGroup,BaseApiUrl } from "../../api/api";
  export default {
    props: {},
    data() {
      return {
        token: {
          Authorization: "Bearer ",
        },
        fileAction: BaseApiUrl + "/images/Upload/PicOne",
        addFormVisible:true,
        addForm: {
          Id:0,
          Name: "",
          MachineNO:"",
          Content:"",
          Address:"",
        },
        addLoading: false,
        addFormRules: {
          Name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        },
      };
    },
    methods: {
      closetc(index) { 
        this.$parent.closetc(); //将值传给父组件 
      },
      //新增
      addSubmit: function () {
        let _this = this;
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.$confirm("确认提交吗？", "提示", {}).then(() => {
              this.addLoading = true;
              //NProgress.start();
              let para = Object.assign({}, this.addForm);
              var user = JSON.parse(window.localStorage.user);
              if (user && user.uID > 0) {
              } else {
                this.$message({
                  message: "用户信息为空，先登录",
                  type: "error",
                });
                _this.$router.replace(
                  _this.$route.query.redirect ? _this.$route.query.redirect : "/"
                );
              }
              
              addMachinesGroup(para).then((res) => {
                this.addLoading = false;
                if (res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  }); 
                  this.$parent.closetc(1);
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            });
          }
        });
      },
    },
    mounted() { 
        let tokenStr = window.localStorage.Token;
        this.token = {
            Authorization: "Bearer " + tokenStr,
        };
    },
  };
  </script> 